/**
 * Which screen of the new evals is on, derived from the URL.
 *
 *   (none)                               → list
 *   ?mode=create[&template=<id>]         → create (name, description, target, settings), optionally
 *                                          filled in from a template
 *   ?mode=queue[&eval=<id>]              → the grading queue, optionally for one eval
 *   ?mode=proposals[&eval=<id>]          → proposed changes to review, optionally for one eval
 *   ?eval=<lineage id>[&run=<id>]        → results — an eval's home: verdicts, queue, analysis;
 *                                          optionally with one run open
 *   ?eval=<id>&mode=edit[&version=<n>]   → edit mode (the graph, the node panels, versions),
 *                                          optionally previewing an old version
 *   ?eval=<id>&mode=results[…]           → results, the older spelling (kept: issues and the
 *                                          trace verdicts panel link to it)
 *   …&filter=failed|passed|errored       → results opened on that outcome (an eval alert links here)
 *
 * The parameter is `eval`, not the current evals' `evaluator`, so the two
 * systems never read each other's URL state when the switch flips.
 */

const TEMPLATE_RE = /^[a-z0-9]+(-[a-z0-9]+)*$/;
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const FILTERABLE = new Set(['queue', 'proposals']);
const OUTCOMES = new Set(['passed', 'failed', 'errored']);
const uuidOrNull = (raw) => (raw && UUID_RE.test(raw) ? raw.toLowerCase() : null);

export function viewFromParams(searchParams) {
  const mode = searchParams.get('mode');
  const id = uuidOrNull(searchParams.get('eval'));
  if (mode === 'create') {
    const template = searchParams.get('template');
    return template && TEMPLATE_RE.test(template) ? { name: 'create', template } : { name: 'create' };
  }
  if (FILTERABLE.has(mode)) return id ? { name: mode, id } : { name: mode };
  if (id) {
    if (mode === 'edit') {
      const version = Number(searchParams.get('version'));
      return Number.isInteger(version) && version > 0 ? { name: 'editor', id, previewVersion: version } : { name: 'editor', id };
    }
    const runId = uuidOrNull(searchParams.get('run'));
    const filter = OUTCOMES.has(searchParams.get('filter')) ? searchParams.get('filter') : null;
    return { name: 'results', id, ...(runId ? { runId } : {}), ...(filter ? { filter } : {}) };
  }
  return { name: 'list' };
}

export function paramsForView(next) {
  const p = new URLSearchParams();
  if (next.name === 'create') { p.set('mode', 'create'); if (next.template) p.set('template', next.template); }
  else if (FILTERABLE.has(next.name)) { p.set('mode', next.name); if (next.id) p.set('eval', next.id); }
  else if (next.name === 'editor') { p.set('eval', next.id); p.set('mode', 'edit'); if (next.previewVersion) p.set('version', String(next.previewVersion)); }
  else if (next.name === 'results') { p.set('eval', next.id); if (next.runId) p.set('run', next.runId); if (next.filter) p.set('filter', next.filter); }
  return p;
}
